function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#current-stock_svg__clip0_4332_7897)",
  stroke: "#4D4D4D",
  strokeWidth: 2.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M53.749 3.857h2.4c4.367 0 8.096 2.182 10.196 5.678M47.32 3.857h2.4M16.55 68.4h-1.2c-4.356 0-8.105-2.214-10.207-5.694M22.635 68.4h-2.4",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.149 63.6h-40.8a7.2 7.2 0 01-7.2-7.2V15.6a7.2 7.2 0 017.2-7.2h40.8a7.2 7.2 0 017.2 7.2v40.8a7.2 7.2 0 01-7.2 7.2zM8.149 18h55.2",
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.149 36h43.2M14.149 45.6h43.2M28.549 26.4v28.8M42.95 26.4v28.8",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.149 27.4a1 1 0 011-1h41.2a1 1 0 011 1v26.8a1 1 0 01-1 1h-41.2a1 1 0 01-1-1V27.4z",
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.178 12.857h1.285M20.32 12.857h1.286M25.463 12.857h1.286",
  strokeLinecap: "round"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "current-stock_svg__clip0_4332_7897"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h72v72H0z"
})));

function SvgCurrentStock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "/img/current-stock.svg";
export { SvgCurrentStock as ReactComponent };